export function formatApartmentGroup(apartmentGroup) {
    if (apartmentGroup === 'HAB') return 'DB';
    return apartmentGroup;
}